import {Text, type TextProps} from '@primer/react'

import type {FuzzyFilterChunk} from '../../helpers/suggester'
import styles from './highlighted-text.module.css'

interface HighlightedTextProps extends TextProps {
  text: string
  chunks: Array<FuzzyFilterChunk>
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({text, chunks, ...textProps}) => {
  return (
    <Text {...textProps}>
      {chunks.map(chunk => {
        const textChunk = text.substr(chunk.startIndex, chunk.endIndex - chunk.startIndex)
        return chunk.highlight ? (
          <mark key={chunk.startIndex.toString()} className={styles.highlightedText}>
            {textChunk}
          </mark>
        ) : (
          textChunk
        )
      })}
    </Text>
  )
}

try{ HighlightedText.displayName ||= 'HighlightedText' } catch {}